import { TechnologiesParser } from '@services/http/parsers/technologies-response.parser';
import { SnfIntlHttpRemoteCall } from '../snf-intl.http-remote-call';

export class GetTechnologiesRemoteCall extends SnfIntlHttpRemoteCall {
  /**
   * @inheritdoc
   */
  relativePath = 'tecnologies';

  /**
   * @inheritdoc
   */
  responseParser = new TechnologiesParser();

  /**
   * @inheritdoc
   */
  constructor(id, language) {
    super(language);
    this.relativePath = `${this.relativePath}/${id}`;
  }

  cache = true;

  getQuery() {
    return {
      ...super.getQuery()
    };
  }
}
